import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTimeline } from '../services';

// Thunk asíncrono para obtener los datos de team desde la API
export const fetchTimelineData = createAsyncThunk(
    'team/fetchTimelineData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchTimeline();
            // console.log(data)
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const timelineSlice = createSlice({
    name: 'timeline',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTimelineData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTimelineData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchTimelineData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default timelineSlice.reducer;
